module.exports = __webpack_public_path__ + "static/media/household_door_wooden_internal_shut_011.34bc90db.wav";